import VueApexCharts from 'vue-apexcharts'
import api from '../../services/service_report'
import Swal from 'sweetalert2'
import moment from 'moment'
import Con from '../../../static/config.json'

export default {
  data () {
    const baseUrl = Con.URL
      .replace(/index\.php\/?$/, '')
      .replace(/\/api\/?$/, '/')
    return {
      dateNow: this.dateMonth(new Date()),
      data_water: '',
      data_list: [],
      zone_list: [],
      zone: '',
      data_month: '',
      pdf_url: baseUrl + 'pdf/reportwater_pdf.php',
      excel_url: baseUrl + 'excel/reportwater_excel.php',
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      }
    }
  },
  components: {
    apexchart: VueApexCharts
  },
  methods: {
    getZoneAll () {
      var obj = {
        search: '',
        active_page: 1,
        per_page: 100000000
      }
      api.getZone(obj, this.header,
        result => {
          if (result.response === true) {
            this.zone_list = result.data.pagination
          } else {
            Swal.fire('ดึงข้อมูลสิทธิ์', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    getWaterReport () {
      this.data_list = []
      this.$store.state.isLoading = true
      api.getWaterReport(
        {
          search: '',
          zone: this.zone
        },
        this.header,
        result => {
          if (result.response === true) {
            this.$store.state.isLoading = false
            this.data_list = result.data
            this.data_water = JSON.stringify(result.data)
            this.data_month = this.monthYearFormat(this.dateNow)
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
            this.$store.state.isLoading = false
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    this.getZoneAll()
    this.getWaterReport()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/report_water.js